module.exports = __webpack_public_path__ + "media/images/expert-slide2-thumb-e06302140c62c58525f43669f718c3b4791bca3cfe67251b56b84cbd08d8f6bd.jpg";